/// <amd-module name="InstantSearch/Shared/Constants" />
export const KeyDebounceTimeMs = 200;
export const AllHubs = "All";
export const InstantSearchProjectContextMenuContribution = "ms.vss-work-web.instant-search-project-menu";
export const InstantSearchCollectionContextMenuContribution = "ms.vss-work-web.instant-search-collection-menu";
export const InstantSearchDebouncedDelayInMs = "Search/InstantSearch/DebouncedDelayInMs";
export const KeyDebounceTimeMs2 = 500;
export const InstantSearchDelayFeature = "WebAccess.Search.WorkItem.InstantSearch.Delay";
export const RemovePackageSearchFromInstantSearch = "WebAccess.Search.WorkItem.InstantSearch.RemovePackageSearch";

export namespace CustomerIntelligenceConstants {
    export const Area = "Web";
    export const FeatureArea = "SearchPortal";
    export const Feature = "WorkItemSearchSuggestions";
}
